module.exports = __webpack_public_path__ + "static/media/table1-fruit.4ece749e.png";